module.exports = __webpack_public_path__ + "img/select-3-4.0b4cb585.png";